var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Option from "fp-ts/lib/Option";
import * as Either from "fp-ts/lib/Either";
import { isFuture, getDurationFromNow } from "core/utils/date";
import { getHeroCategory, getHeroList, getHeroVariant } from "./utils/hero";
export function checkForCountdown(data) {
    if (data.countdown !== null) {
        var duration = getDurationFromNow(data.countdown.datetime);
        if (Either.isRight(duration)) {
            return Option.some({
                kind: "Countdown",
                cta: data.cta,
                countdown: data.countdown,
                duration: duration.right,
            });
        }
    }
    return Option.none;
}
export function checkForArrow(data) {
    if (data.cta !== null) {
        var arrow = {
            kind: "Arrow",
            cta: __assign(__assign({}, data.cta), { link: __assign(__assign({}, data.cta.link), { trackingObject: {
                        list: getHeroList(data),
                        product: {
                            id: data.type === "CustomDynamicHero" ? data.uuid : data.program,
                            name: data.title,
                            category: getHeroCategory(data),
                            variant: getHeroVariant(data),
                        },
                    } }) }),
        };
        return Option.some(arrow);
    }
    return Option.none;
}
export function checkForVtmGoWithAiring(data) {
    // return live button if allowed
    if (data.airing !== null &&
        data.airing.type === "on_air" &&
        data.nextBroadcast !== null) {
        if (!isFuture(data.nextBroadcast.start) &&
            isFuture(data.nextBroadcast.end)) {
            return Option.some({
                kind: "VtmGoLive",
                updateTime: data.nextBroadcast.end,
            });
        }
    }
    // return on demand button if allowed
    if (data.vtmgoConversionEnabled) {
        return Option.some({
            kind: "VtmGoOnDemand",
            updateTime: Option.none,
            url: data.vtmgoUrl,
        });
    }
    return Option.none;
}
export function checkForVtmGoWithOnAir(data) {
    if (data.vtmgoConversionEnabled && data.onAir !== null) {
        if (isFuture(data.onAir.start)) {
            return Option.some({
                kind: "Blank",
                updateTime: data.onAir.start,
            });
        }
        if (!isFuture(data.onAir.start) && isFuture(data.onAir.end)) {
            return Option.some({
                kind: "VtmGoLive",
                updateTime: data.onAir.end,
            });
        }
    }
    return Option.none;
}
export function checkForVtmGoPlusExclusive(data) {
    if (data.vtmgoConversionEnabled && data.vtmgoPlusExclusive) {
        return Option.some({
            kind: "VtmGoPlus",
            url: data.vtmgoUrl,
        });
    }
    return Option.none;
}
